import { Link } from '../../base/Link/Link';
import styles from './BackBar.module.css';

interface BackBarProps {
  onBack: () => void;
}

export function BackBar({ onBack }: BackBarProps) {
  const handleBackClick = (event: MouseEvent) => {
    event.preventDefault();
    onBack();
  };

  return (
    <div className={styles.backBar} data-testid="back-bar">
      <Link
        href="#"
        onClick={handleBackClick}
        icon="chevronLeft"
        iconPosition="start"
      >
        Back
      </Link>
    </div>
  );
}
